import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { urlHelpers } from "altice_react_helpers";
import * as cartActions from "../actions/creators/cartAction";
import * as cartResourcesActions from "../actions/creators/cartResourcesAction";
import * as cartSettingsActions from "../actions/creators/cartSettingsAction";

const root = (WrappedComponent) => {
	class Root extends Component {
		componentDidMount() {
			const cartId = urlHelpers.getParameterByName(
				"cartid",
				this.props.location.search
			);
			this.props.dispatch(cartActions.fetchCart(this.props.readOnly, cartId));
			this.props.dispatch(cartResourcesActions.fetchCartResources());
			this.props.dispatch(cartSettingsActions.fetchCartSettings());
			//                                    .catch((e) => {console.log('error getting settings')});
		}

		render() {
			return <WrappedComponent {...this.state} {...this.props} />;
		}
	}

	const mapStateToProps = (state) => {
		return {
			cartReducer: state.cartReducer,
			voucherReducer: state.voucherReducer,
			cartResourcesReducer: state.cartResourcesReducer,
			cartSettingsReducer: state.cartSettingsReducer
		};
	};

	return withRouter(connect(mapStateToProps)(Root));
};

export default root;
